import { render, staticRenderFns } from "./impresion_salida.vue?vue&type=template&id=5f27c301&lang=pug&"
import script from "./impresion_salida.vue?vue&type=script&lang=js&"
export * from "./impresion_salida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports